<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import QRCode from "qrcode";
import canvasToBlob from "canvas-to-blob";
/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.$t("menuitems.devices.devicedetail"),
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Starter page",
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Starter page",
          active: true,
        },
      ],
      devicelist: [],
      devicesearch: "",
      getdeviceslist: "",
      selectdevicestatus: "-1",

      ismobile: false,
      activeNames: [],
      activeapp: [],
      showmodel: "1",
      deviceid: "",
      devicesdetail: [],
      setting: [],
      userinfo: [],
      noticelist: [],
      qrcode: "",
      deviceserver: [],
      loading: true,
      devicename_edit: false,
      devicenamevalue: "",
      systemtype: 0,
      qrCode: "",
      showScreenPicUpload: false,
      imageUrl: "",
      loadingScreenPicStatus: false,
      loadingScreenText: "",
      showRuntimeSettingDialog: false,
      runtimeBegin: "",
      runtimeEnd: "",
      // 设备日志相关
      showStockLogDialog: false,
      showMaintainLogDialog: false,
      stockLogList: [],
      maintainLogList: [],
      stockLogLoading: false,
      maintainLogLoading: false,
      stockLogPage: 1,
      stockLogLimit: 20,
      stockLogTotal: 0,
      maintainLogPage: 1,
      maintainLogLimit: 20,
      maintainLogTotal: 0,
      portugalCupPrice: "0.00",
      portugalSoldoutStatus: 2,
      portugalSoldOutPage: 0,
      portugalNormalPage: 0,
      portugalCommMode: 0,
      portugalPulse: { 1: 0, 2: 0, 3: 0, 4: 0 },
      portugalExceptionList: [],
      portugalExceptionLoading: false,
      portugalExceptionPage: 1,
      portugalExceptionLimit: 10,
      portugalExceptionTotal: 0,
    };
  },
  mounted() {
    var that = this;
    that.title = that.$t("menuitems.devices.devicedetail");
    that.items = [
      {
        text: that.$t("menuitems.devices.text"),
        href: "/",
      },
      {
        text: that.$t("menuitems.devices.lists"),
        href: "/device/list",
      },
      {
        text: that.$t("menuitems.devices.devicedetail"),
        active: true,
      },
    ];

    that.userinfo = JSON.parse(localStorage.getItem("user"));

    let flag = navigator.userAgent.match(
      /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      // that.ismobile = true;
    }
    that.deviceid = that.$route.query.id;
    that.getdeviceinfo();
    that.getsysteminfo();
  },
  methods: {
    getsysteminfo() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "systeminfo",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.systemtype = parseInt(response.data.data.model);
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    getdeviceinfo() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getdeivces",
            id: that.$route.query.id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          that.devicesdetail = response.data.data;
          that.setting = response.data.settingv2 || {};
          that.portugalCupPrice = Number(that.setting.cup_price ?? 0).toFixed(2);
          that.portugalCommMode = Number(that.setting.comm_mode ?? 0);
          that.portugalSoldoutStatus = Number(that.setting.soldout_status ?? 2);
          that.portugalSoldOutPage = Number(that.setting.sold_out_page ?? 0);
          that.portugalNormalPage = Number(that.setting.normal_page ?? 0);
          var pulse = that.setting.pulse || {};
          that.portugalPulse = {
            1: Number(pulse[1] ?? pulse["1"] ?? 0),
            2: Number(pulse[2] ?? pulse["2"] ?? 0),
            3: Number(pulse[3] ?? pulse["3"] ?? 0),
            4: Number(pulse[4] ?? pulse["4"] ?? 0),
          };
          if (Number(that.devicesdetail.subid) === 7720) {
            that.portugalExceptionPage = 1;
            that.loadPortugalExceptions();
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    copyLink: function (dom) {
      let _this = this;
      let clipboard = new this.clipboard("." + dom);
      clipboard.on("success", function () {
        _this.$toast(_this.$t("global.copy.success"));
      });
      clipboard.on("error", function () {
        _this.$toast(_this.$t("global.copy.fail"));
      });
    },
    opendoor: function (id) {
      var that = this;
      that.$toast.loading({
        message: that.$t("global.loading.reading"),
        forbidClick: true,
      });
      that.$axios
        .post(
          that.apiuri,
          {
            action: "gethdinfo",
            id: id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.$toast.clear();
          that
            .$prompt(
              that.$t("device.detail.pleaseenterhd", {
                number: response.data.data.device.hd_num,
              }),
              that.$t("global.waring"),
              {
                confirmButtonText: that.$t("global.button.ok"),
                cancelButtonText: that.$t("global.button.cancel"),
                inputType: "number",
                inputPattern: /^[0-9]+.?[0-9]*$/,
                inputErrorMessage: that.$t("device.detail.pleaseinputtrue"),
              }
            )
            .then(({ value }) => {
              if (value > 0 && value <= response.data.data.device.hd_num) {
                that.$axios
                  .post(
                    that.apiuri,
                    {
                      action: "opendoor",
                      id: id,
                      hd: value,
                    },
                    {
                      headers: { Openid: that.userinfo.openid },
                    }
                  )
                  .then(function (response) {
                    that.$toast.clear();
                    if (response.data.status == 200) {
                      that.$message({
                        message: that.$t("global.success"),
                        type: "success",
                      });
                    } else if (response.data.status == 207) {
                      that.$message.error(that.$t("device.lists.offline"));
                    } else {
                      that.$message.error(that.$t("global.delete.500"));
                    }
                  })
                  .catch(function (error) {
                    // console.log(error);
                  });
              } else {
                that.$message.error(that.$t("device.detail.pleaseinputtrue"));
              }
            })
            .catch(() => { });
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    closedoor: function (id) {
      var that = this;
      that.$toast.loading({
        message: that.$t("global.loading.reading"),
        forbidClick: true,
      });
      that.$axios
        .post(
          that.apiuri,
          {
            action: "gethdinfo",
            id: id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.$toast.clear();
          that
            .$prompt(
              that.$t("device.detail.pleaseenterhd", {
                number: response.data.data.device.hd_num,
              }),
              that.$t("global.waring"),
              {
                confirmButtonText: that.$t("global.button.ok"),
                cancelButtonText: that.$t("global.button.cancel"),
                inputType: "number",
                inputPattern: /^[0-9]+.?[0-9]*$/,
                inputErrorMessage: that.$t("device.detail.pleaseinputtrue"),
              }
            )
            .then(({ value }) => {
              if (value > 0 && value <= response.data.data.device.hd_num) {
                that.$axios
                  .post(
                    that.apiuri,
                    {
                      action: "closedoor",
                      id: id,
                      hd: value,
                    },
                    {
                      headers: { Openid: that.userinfo.openid },
                    }
                  )
                  .then(function (response) {
                    that.$toast.clear();
                    if (response.data.status == 200) {
                      that.$message({
                        message: that.$t("global.success"),
                        type: "success",
                      });
                    } else if (response.data.status == 207) {
                      that.$message.error(that.$t("device.lists.offline"));
                    } else {
                      that.$message.error(that.$t("global.delete.500"));
                    }
                  })
                  .catch(function (error) {
                    // console.log(error);
                  });
              } else {
                that.$message.error(that.$t("device.detail.pleaseinputtrue"));
              }
            })
            .catch(() => { });
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    restart: function (id) {
      var that = this;
      that
        .$confirm(
          that.$t("global.waring"),
          that.$t("device.detail.restarttip"),
          {
            confirmButtonText: that.$t("global.button.ok"),
            cancelButtonText: that.$t("global.button.cancel"),
            type: "warning",
          }
        )
        .then(() => {
          that.$toast.loading({
            message: that.$t("global.loading.reading"),
            forbidClick: true,
          });
          that.$axios
            .post(
              that.apiuri,
              {
                action: "restart",
                id: id,
              },
              {
                headers: { Openid: that.userinfo.openid },
              }
            )
            .then(function (response) {
              that.$toast.clear();
              if (response.data.status == 200) {
                that.$message({
                  message: that.$t("global.success"),
                  type: "success",
                });
              } else if (response.data.status == 207) {
                that.$message.error(that.$t("device.lists.offline"));
              } else {
                that.$message.error(that.$t("global.delete.500"));
              }
            })
            .catch(function (error) {
              // console.log(error);
            });
        })
        .catch(() => { });
    },
    maintenance: function (action, id) {
      var that = this;
      if (action == "open") {
        var tips = that.$t("device.detail.openmaintenance");
      } else {
        var tips = that.$t("device.detail.closemaintenance");
      }
      that
        .$confirm(that.$t("global.waring"), tips, {
          confirmButtonText: that.$t("global.button.ok"),
          cancelButtonText: that.$t("global.button.cancel"),
          type: "warning",
        })
        .then(() => {
          that.$toast.loading({
            message: that.$t("global.loading.reading"),
            forbidClick: true,
          });
          that.$axios
            .post(
              that.apiuri,
              {
                action: "maintenance",
                jofs: action,
                id: id,
              },
              {
                headers: { Openid: that.userinfo.openid },
              }
            )
            .then(function (response) {
              that.$toast.clear();
              that.getdeviceinfo();
              if (response.data.status == 200) {
                that.$message({
                  message: that.$t("global.success"),
                  type: "success",
                });
              } else if (response.data.status == 207) {
                that.$message.error(that.$t("device.lists.offline"));
              } else {
                that.$message.error(that.$t("global.delete.500"));
              }
            })
            .catch(function (error) {
              // console.log(error);
            });
        })
        .catch(() => { });
    },
    showstockresetlog: function (id) {
      this.showStockLogDialog = true;
      this.stockLogPage = 1;
      this.getStockLogList(id);
    },
    showmaintainlog: function (id) {
      this.showMaintainLogDialog = true;
      this.maintainLogPage = 1;
      this.getMaintainLogList(id);
    },
    getStockLogList(id) {
      this.stockLogLoading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "getstockresetlog",
            id: id,
            page: this.stockLogPage,
            limit: this.stockLogLimit
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.stockLogLoading = false;
          if (response.data.status === 200) {
            this.stockLogList = response.data.data || [];
            this.stockLogTotal = response.data.total || 0;
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.loaddata"));
            this.stockLogList = [];
            this.stockLogTotal = 0;
          }
        })
        .catch((error) => {
          this.stockLogLoading = false;
          console.error("获取库存重置日志失败:", error);
          this.$message.error(this.$t("global.errors.network"));
          this.stockLogList = [];
          this.stockLogTotal = 0;
        });
    },
    getMaintainLogList(id) {
      this.maintainLogLoading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "getmaintainlog",
            id: id,
            page: this.maintainLogPage,
            limit: this.maintainLogLimit
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.maintainLogLoading = false;
          if (response.data.status === 200) {
            this.maintainLogList = response.data.data || [];
            this.maintainLogTotal = response.data.total || 0;
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.loaddata"));
            this.maintainLogList = [];
            this.maintainLogTotal = 0;
          }
        })
        .catch((error) => {
          this.maintainLogLoading = false;
          console.error("获取维护日志失败:", error);
          this.$message.error(this.$t("global.errors.network"));
          this.maintainLogList = [];
          this.maintainLogTotal = 0;
        });
    },
    handleStockLogPageChange(page) {
      this.stockLogPage = page;
      this.getStockLogList(this.deviceid);
    },
    handleStockLogSizeChange(size) {
      this.stockLogLimit = size;
      this.stockLogPage = 1;
      this.getStockLogList(this.deviceid);
    },
    handleMaintainLogPageChange(page) {
      this.maintainLogPage = page;
      this.getMaintainLogList(this.deviceid);
    },
    handleMaintainLogSizeChange(size) {
      this.maintainLogLimit = size;
      this.maintainLogPage = 1;
      this.getMaintainLogList(this.deviceid);
    },
    getwechatqrcode: function (id) {
      var that = this;
      that.$toast.loading({
        message: that.$t("global.loading.reading"),
        forbidClick: true,
      });

      that.$axios
        .post(
          that.apiuri,
          {
            action: "getwechatqrcode",
            id: id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.$toast.clear();
          if (response.data.status == 200) {
            that.$alert(
              "<img src='https://paygay.aic.xin/qr.png?data=" +
              response.data.img +
              "' width='100%'/>",
              that.$t("device.button.qrcode"),
              {
                dangerouslyUseHTMLString: true,
              }
            );
          } else {
            that.$message.error(that.$t("global.delete.500"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    showdeviceqrdiy: function () {
      var that = this;
      that.$alert(
        "<img src='https://paygay.aic.xin/qr.png?data=https://mdy.aicoiot.beer/user" +
        that.userinfo.id +
        ".html?sn=" +
        that.devicesdetail.device_sn +
        "' width='100%'/>",
        that.$t("device.button.qrcode"),
        {
          dangerouslyUseHTMLString: true,
        }
      );
    },
    showdeviceqr: function () {
      var that = this;
      that.$alert(
        "<img src='https://paygay.aic.xin/qr.png?data=https://menu.aicoiot.beer/" +
        that.devicesdetail.device_sn +
        ".memu' width='300px' height='300px'/>",
        that.$t("device.button.qrcode"),
        {
          dangerouslyUseHTMLString: true,
        }
      );
    },
    opensharing: function (id) {
      var that = this;
      that.$toast.loading({
        message: that.$t("global.loading.reading"),
        forbidClick: true,
      });

      that.$axios
        .post(
          that.apiuri,
          {
            action: "switchshring",
            type: "open",
            id: id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.$toast.clear();
          if (response.data.status == 200) {
            that.getdeviceinfo();
            that.$message({
              message: that.$t("global.success"),
              type: "success",
            });
          } else {
            that.$message.error(that.$t("global.delete.500"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    closesharing: function (id) {
      var that = this;
      that.$toast.loading({
        message: that.$t("global.loading.reading"),
        forbidClick: true,
      });

      that.$axios
        .post(
          that.apiuri,
          {
            action: "switchshring",
            type: "close",
            id: id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.$toast.clear();
          if (response.data.status == 200) {
            that.getdeviceinfo();
            that.$message({
              message: that.$t("global.success"),
              type: "success",
            });
          } else {
            that.$message.error(that.$t("global.delete.500"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    complex: function (id) { },
    itialization: function (id) {
      var that = this;
      that
        .$confirm(
          that.$t("global.waring"),
          that.$t("device.detail.itialization"),
          {
            confirmButtonText: that.$t("global.button.ok"),
            cancelButtonText: that.$t("global.button.cancel"),
            type: "warning",
          }
        )
        .then(() => {
          that.$toast.loading({
            message: that.$t("global.loading.reading"),
            forbidClick: true,
          });
          that.$axios
            .post(
              that.apiuri,
              {
                action: "itialization",
                id: id,
              },
              {
                headers: { Openid: that.userinfo.openid },
              }
            )
            .then(function (response) {
              that.$toast.clear();
              if (response.data.status == 200) {
                that.$message({
                  message: that.$t("global.success"),
                  type: "success",
                });
              } else {
                that.$message.error(that.$t("global.failed"));
              }
            })
            .catch(function (error) {
              // console.log(error);
            });
        })
        .catch(() => { });
    },
    opensafedoor: function (id) {
      var that = this;
      that
        .$confirm(
          that.$t("global.waring"),
          that.$t("device.detail.openthesafedoor"),
          {
            confirmButtonText: that.$t("global.button.ok"),
            cancelButtonText: that.$t("global.button.cancel"),
            type: "warning",
          }
        )
        .then(() => {
          that.$toast.loading({
            message: that.$t("global.loading.reading"),
            forbidClick: true,
          });
          that.$axios
            .post(
              that.apiuri,
              {
                action: "opensafedoor",
                id: id,
              },
              {
                headers: { Openid: that.userinfo.openid },
              }
            )
            .then(function (response) {
              that.$toast.clear();
              if (response.data.status == 200) {
                that.$message({
                  message: that.$t("global.success"),
                  type: "success",
                });
              } else {
                that.$message.error(that.$t("global.failed"));
              }
            })
            .catch(function (error) {
              // console.log(error);
            });
        })
        .catch(() => { });
    },
    changemode: function (id, type) {
      var that = this;
      if (type == "pay") {
        var modetext = that.$t("device.detail.switchpaymentmode");
      } else {
        var modetext = that.$t("device.detail.switchhandemode");
      }
      that
        .$confirm(modetext, that.$t("global.waring"), {
          confirmButtonText: that.$t("global.button.ok"),
          cancelButtonText: that.$t("global.button.cancel"),
          type: "warning",
        })
        .then(() => {
          that.$toast.loading({
            message: that.$t("global.loading.reading"),
            forbidClick: true,
          });
          that.$axios
            .post(
              that.apiuri,
              { action: "changemode", ED_id: id, type: type },
              { headers: { Openid: that.userinfo.openid } }
            )
            .then(function (response) {
              that.$toast.clear();
              if (response.data.status == 200) {
                that.$message({
                  message: that.$t("global.success"),
                  type: "success",
                });
              } else {
                that.$message.error(that.$t("global.failed"));
              }
            });
        });
    },
    changedeviceserver: function (id) {
      var that = this;
      that.$toast.loading({
        message: that.$t("global.loading.reading"),
        forbidClick: true,
      });

      that.$axios
        .post(
          that.apiuri,
          {
            action: "getnowserver",
            id: id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.$toast.clear();
          if (response.data.status == 200) {
            that.deviceserver = response.data.data;
            that.$alert("", that.$t("device.detail.changeserver"), {
              dangerouslyUseHTMLString: true,
            });
          } else {
            that.$message.error(that.$t("global.delete.500"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    getipinfos: function (id) {
      var that = this;
      that.$toast.loading({
        message: that.$t("global.loading.reading"),
        forbidClick: true,
      });
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getclientip",
            edid: id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.$toast.clear();
          if (response.data.status == 200) {
            that.deviceserver = response.data.data;
            that.$alert(
              that.$t("device.detail.country") +
              "：" +
              response.data.data.country +
              "<br/>" +
              that.$t("device.detail.area") +
              "：" +
              response.data.data.area +
              "<br/>" +
              that.$t("device.detail.region") +
              "：" +
              response.data.data.region +
              "<br/>" +
              that.$t("device.detail.city") +
              "：" +
              response.data.data.city +
              "<br/>" +
              that.$t("device.detail.county") +
              "：" +
              response.data.data.county +
              "<br/>" +
              that.$t("device.detail.isp") +
              "：" +
              response.data.data.isp +
              "<br/>" +
              that.$t("device.detail.ip") +
              "：" +
              response.data.data.ip,
              that.$t("device.detail.ip"),
              {
                dangerouslyUseHTMLString: true,
              }
            );
          } else {
            that.$message.error(that.$t("global.delete.500"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    commanddebug: function (id) {
      var that = this;
      that.$toast.loading({
        message: that.$t("global.loading.reading"),
        forbidClick: true,
      });
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getdeviceserror",
            id: id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.$toast.clear();
          if (response.data.status == 200) {
            that.$toast.loading({
              message: that.$t("global.loading.wating"),
              forbidClick: true,
            });
            setTimeout(function () {
              that.getdeviceinfo();
              that.$toast.clear();
            }, 5000);
          } else {
            that.$message.error(that.$t("global.delete.500"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    devicecheckout(id) {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "barcheckout",
            id: id,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          if (response.data.status == 200) {
            that.$message({
              message: that.$t("global.success"),
              type: "success",
            });
          } else if (response.data.status == 404) {
            that.$message.error(that.$t("device.lists.offline"));
          } else {
            that.$message.error(that.$t("global.delete.500"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    changedevicename() {
      // this.$t("menuitems.marketing.micoapp.text")
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "savedeviceinfo",
            id: that.deviceid,
            key: "name",
            value: that.devicenamevalue,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          that.devicename_edit = false;
          if (response.data.status == 200) {
            that.getdeviceinfo();
          } else {
            that.$message.error(that.$t("global.delete.500"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    updategoodsinfo(device) {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "updategoods",
            id: device,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          if (response.data.status == 200) {
            that.$message({
              message: that.$t("global.success"),
              type: "success",
            });
          } else {
            that.$message.error(that.$t("global.delete.500"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    updatedevicestatus(device) {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "updatedevicestatus",
            id: device,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          if (response.data.status == 200) {
            that.$message({
              message: that.$t("global.success"),
              type: "success",
            });
          } else {
            that.$message.error(that.$t("global.delete.500"));
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    portugalPushAction(action, device, extra) {
      var that = this;
      that.loading = true;
      var payload = Object.assign({ action: action, id: device }, extra || {});
      that.$axios
        .post(that.apiuri, payload, {
          headers: { Openid: that.userinfo.openid },
        })
        .then(function (response) {
          that.loading = false;
          if (response.data.status == 200) {
            if (!that.setting) that.setting = {};
            if (action === "portugal4lanesetgoods" && response.data.data && response.data.data.cup_price != null) {
              that.portugalCupPrice = Number(response.data.data.cup_price).toFixed(2);
              that.setting.cup_price = Number(that.portugalCupPrice);
            }
            if (action === "portugal4lanesetcommmode") {
              that.setting.comm_mode = Number(that.portugalCommMode);
            }
            if (action === "portugal4lanesetsoldout") {
              that.setting.soldout_status = Number(that.portugalSoldoutStatus);
              that.setting.sold_out_page = Number(that.portugalSoldOutPage);
              that.setting.normal_page = Number(that.portugalNormalPage);
            }
            if (action === "portugal4lanesetpulse") {
              var pulseData =
                response.data.data && response.data.data.pulse
                  ? response.data.data.pulse
                  : that.portugalPulse;
              that.portugalPulse = {
                1: Number(pulseData[1] ?? pulseData["1"] ?? 0),
                2: Number(pulseData[2] ?? pulseData["2"] ?? 0),
                3: Number(pulseData[3] ?? pulseData["3"] ?? 0),
                4: Number(pulseData[4] ?? pulseData["4"] ?? 0),
              };
              that.setting.pulse = that.portugalPulse;
            }
            that.$message({
              message: response.data.msg || that.$t("global.success"),
              type: "success",
            });
          } else if (response.data.status == 404) {
            that.$message.error(that.$t("device.lists.offline"));
          } else {
            that.$message.error(response.data.msg || that.$t("global.failed"));
          }
        })
        .catch(function () {
          that.loading = false;
          that.$message.error(that.$t("global.failed"));
        });
    },
    portugalSyncGoods(device) {
      this.portugalPushAction("portugal4lanesetgoods", device);
    },
    portugalSyncRemain(device) {
      this.portugalPushAction("portugal4lanesetremain", device);
    },
    portugalSaveCupPrice(device) {
      var yuan = parseFloat(this.portugalCupPrice);
      if (isNaN(yuan) || yuan < 0) {
        yuan = 0;
      }
      yuan = Math.round(yuan * 100) / 100;
      this.portugalCupPrice = yuan.toFixed(2);
      var cents = Math.round(yuan * 100);
      this.portugalPushAction("portugal4lanesetgoods", device, {
        cup_price_cents: cents,
        cup_price: yuan.toFixed(2),
      });
    },
    portugalFormatCupPrice() {
      var yuan = parseFloat(this.portugalCupPrice);
      if (isNaN(yuan) || yuan < 0) {
        yuan = 0;
      }
      this.portugalCupPrice = yuan.toFixed(2);
    },
    portugalSetSoldout(device) {
      this.portugalPushAction("portugal4lanesetsoldout", device, {
        status: this.portugalSoldoutStatus,
        sold_out_page: this.portugalSoldOutPage,
        normal_page: this.portugalNormalPage,
      });
    },
    portugalInitResources(device) {
      this.portugalPushAction("portugal4laneinitresources", device);
    },
    portugalSaveCommMode(device) {
      this.portugalPushAction("portugal4lanesetcommmode", device, {
        mode: this.portugalCommMode,
      });
    },
    portugalSavePulse(device) {
      this.portugalPushAction("portugal4lanesetpulse", device, {
        pulse: {
          1: Number(this.portugalPulse[1] || 0),
          2: Number(this.portugalPulse[2] || 0),
          3: Number(this.portugalPulse[3] || 0),
          4: Number(this.portugalPulse[4] || 0),
        },
      });
    },
    loadPortugalExceptions() {
      var that = this;
      if (!that.devicesdetail || !that.devicesdetail.id) {
        return;
      }
      that.portugalExceptionLoading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "portugal4laneexceptions",
            id: that.devicesdetail.id,
            page: that.portugalExceptionPage,
            limit: that.portugalExceptionLimit,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.portugalExceptionLoading = false;
          if (response.data.status == 200) {
            that.portugalExceptionList = response.data.data || [];
            that.portugalExceptionTotal = response.data.count || 0;
          } else {
            that.portugalExceptionList = [];
            that.portugalExceptionTotal = 0;
          }
        })
        .catch(function () {
          that.portugalExceptionLoading = false;
          that.portugalExceptionList = [];
          that.portugalExceptionTotal = 0;
        });
    },
    handlePortugalExceptionPageChange(page) {
      this.portugalExceptionPage = page;
      this.loadPortugalExceptions();
    },
    portugalExceptionLabel(row) {
      if (!row) return "-";
      if (row.exception_code === "E8808") {
        return this.$t("device.portugal.exception.type_noflow");
      }
      if (row.exception_code === "E8802") {
        return this.$t("device.portugal.exception.type_device");
      }
      return row.exception_label || row.exception_code || "-";
    },
    async showqrcode(devicesn) {
      let hostname = document.location.hostname;

      const canvas = this.$refs.canvas;
      const options = { width: 256, height: 256 };
      const dataUrl = await QRCode.toDataURL(
        "https://cashier" + hostname + "/?sn=" + devicesn,
        options
      );
      canvas.width = options.width;
      canvas.height = options.height;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.onload = () => {
        ctx.drawImage(img, 0, 0, options.width, options.height);
        canvas.toBlob((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            this.qrCode = reader.result;
          };
          reader.readAsDataURL(blob);
        });
      };
      img.src = dataUrl;

      // console.log(this.$refs.canvas)
      this.$alert(
        '<img width="100%" src="' + img.src + '">',
        this.$t("device.button.qrcode"),
        {
          confirmButtonText: this.$t("global.button.ok"),
          dangerouslyUseHTMLString: true,
          callback: (action) => {
            if (action === "confirm") {
              let uri = "https://cashier" + hostname + "/?sn=" + devicesn;
              this.$axios
                .post(
                  this.apiuri,
                  {
                    action: "updatedeviceqrcode",
                    id: this.devicesdetail.ED_id,
                    uri
                  },
                  {
                    headers: { Openid: this.userinfo.openid },
                  }
                )
                .then(function (response) {
                  if (response.data.status == 200) {
                    this.$message({
                      message: this.$t("global.success"),
                      type: "success",
                    });
                  } else {
                    this.$message.error(this.$t("global.delete.500"));
                  }
                })
                .catch(function (error) {
                  // console.log(error);
                });
            }
          },
        }
      );
    },
    resetdevicepwd: function (id) {
      var that = this;
      that
        .$confirm(
          that.$t("global.waring"),
          that.$t("device.detail.resetdevicepwd"),
          {
            confirmButtonText: that.$t("global.button.ok"),
            cancelButtonText: that.$t("global.button.cancel"),
            type: "warning",
          }
        )
        .then(() => {
          that.$toast.loading({
            message: that.$t("global.loading.reading"),
            forbidClick: true,
          });
          that.$axios
            .post(
              that.apiuri,
              {
                action: "resetdevicepwd",
                id: id,
              },
              {
                headers: { Openid: that.userinfo.openid },
              }
            )
            .then(function (response) {
              that.$toast.clear();
              if (response.data.status == 200) {
                that.$message({
                  message: that.$t("global.success"),
                  type: "success",
                });
              } else {
                that.$message.error(that.$t("global.delete.500"));
              }
            })
            .catch(function (error) {
              // console.log(error);
            });
        })
        .catch(() => { });
    },
    switchstocktips: function (ED_id) {
      var that = this;
      that.$toast.loading({
        message: that.$t("global.loading.reading"),
        forbidClick: true,
      });
      if (that.devicesdetail.imei == '0') {
        that.$axios
          .post(
            that.apiuri,
            {
              action: "close_stock_tips",
              id: ED_id,
            },
            {
              headers: { Openid: that.userinfo.openid },
            }
          )
          .then(function (response) {
            that.$toast.clear();
            if (response.data.status == 200) {
              that.getdeviceinfo();
              that.$message({
                message: that.$t("global.success"),
                type: "success",
              });
            } else {
              that.$message.error(that.$t("global.delete.500"));
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
      } else {
        that.$axios
          .post(
            that.apiuri,
            {
              action: "open_stock_tips",
              id: ED_id,
            },
            {
              headers: { Openid: that.userinfo.openid },
            }
          )
          .then(function (response) {
            that.$toast.clear();
            if (response.data.status == 200) {
              that.getdeviceinfo();
              that.$message({
                message: that.$t("global.success"),
                type: "success",
              });
            } else {
              that.$message.error(that.$t("global.delete.500"));
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
      }

    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        // 1️⃣ 检查文件类型
        const isJPG = file.type === 'image/jpeg';
        if (!isJPG) {
          this.$message.error('只能上传 JPG 格式的图片！');
          return reject(false);
        }

        // 2️⃣ 检查文件大小 (单位：字节)
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('图片大小不能超过 2MB！');
          return reject(false);
        }

        // 3️⃣ 检查分辨率
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          const dataUrl = e.target.result;
          const image = new Image();
          image.src = dataUrl;
          image.onload = () => {
            const width = image.width;
            const height = image.height;

            if (width === 1024 && height === 600) {
              // 分辨率符合，允许上传
              resolve(true);
            } else {
              this.$message.error('图片分辨率必须是 1024x600！');
              reject(false);
            }
          };
        };
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      if (res.status === 200) {
        this.loadingScreenPicStatus = true;
        this.loadingScreenText = this.$t("global.loading.screensetting");
        this.$axios
          .post(
            this.apiuri,
            {
              action: "setscreenimages",
              ED_id: this.devicesdetail.ED_id,
              file_lenth: res.filesize,
              file_url: res.imguri
            },
            {
              headers: { Openid: this.userinfo.openid },
            }
          )
          .then((response) => {
            console.log(response.data);
            this.loadingScreenPicStatus = false;
            if (response.data.status == 200) {
              this.$message({
                message: this.$t("global.success"),
                type: "success",
              });
            } else if (response.data.status == 404) {
              this.$message.error(this.$t("device.lists.offline"));
            } else {
              this.$message.error(this.$t("global.delete.500"));
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
      } else {
        this.$message.error(this.$t("global.delete.500"));
      }
    },
    set_stock_if(id) {
      var that = this;
      that.$prompt(that.$t("device.detail.stock_if"), that.$t("update.status.tip"), {
        confirmButtonText: that.$t("global.button.ok"),
        cancelButtonText: that.$t("global.button.cancel"),
        inputValue: that.devicesdetail.sotck_if
      }).then(({ value }) => {
        that.$axios
          .post(
            that.apiuri,
            {
              action: "savedeviceinfo",
              id: id,
              key: "sotck_if",
              value: value
            },
            {
              headers: { Openid: that.userinfo.openid },
            }
          )
          .then(function (response) {
            if (response.data.status == 200) {
              that.getdeviceinfo();
              that.$message({
                message: that.$t("global.success"),
                type: "success",
              });
            } else {
              that.$message.error(that.$t("global.delete.500"));
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
      });
    },
    set_devices_name(id) {
      var that = this;
      that.$prompt(that.$t("device.detail.set_devices_name"), that.$t("update.status.tip"), {
        confirmButtonText: that.$t("global.button.ok"),
        cancelButtonText: that.$t("global.button.cancel"),
        inputValue: that.devicesdetail.name
      }).then(({ value }) => {
        if (value) {
          that.$axios
            .post(
              that.apiuri,
              {
                action: "savedeviceinfo",
                id: id,
                key: "name",
                value: value
              },
              {
                headers: { Openid: that.userinfo.openid },
              }
            )
            .then(function (response) {
              if (response.data.status == 200) {
                that.getdeviceinfo();
                that.$message({
                  message: that.$t("global.success"),
                  type: "success",
                });
              } else {
                that.$message.error(that.$t("global.delete.500"));
              }
            })
            .catch(function (error) {
              // console.log(error);
            });
        } else {
          that.$message.error(that.$t("device.detail.pleaseinputtrue"));
        }

      });
    },
    setRuntimeSetting() {
      var that = this;
      that.showRuntimeSettingDialog = true;
      
      // 从设备详情中获取经营时间，如果没有则使用当前时间作为默认值
      if (that.devicesdetail.runtimebegin && that.devicesdetail.runtimeend) {
        that.runtimeBegin = that.devicesdetail.runtimebegin;
        that.runtimeEnd = that.devicesdetail.runtimeend;
      } else {
        // 如果没有设置过经营时间，使用当前时间作为默认值
        const now = new Date();
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
        that.runtimeBegin = `${hours}:${minutes}:${seconds}`;
        that.runtimeEnd = `${hours}:${minutes}:${seconds}`;
      }
    },
    saveRuntimeSetting() {
      var that = this;
      if (!that.runtimeBegin || !that.runtimeEnd) {
        that.$message.error(that.$t("device.detail.runtime.pleaseinput"));
        return;
      }
      
      that.$toast.loading({
        message: that.$t("global.loading.reading"),
        forbidClick: true,
      });
      
      that.$axios
        .post(
          that.apiuri,
          {
            action: "savedeviceedit",
            id: that.deviceid,
            runtimebegin: that.runtimeBegin,
            runtimeend: that.runtimeEnd,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.$toast.clear();
          that.showRuntimeSettingDialog = false;
          if (response.data.status == 200) {
            that.$message({
              message: that.$t("global.success"),
              type: "success",
            });
            // 更新本地设备详情数据
            that.devicesdetail.runtimebegin = that.runtimeBegin;
            that.devicesdetail.runtimeend = that.runtimeEnd;
          } else if (response.data.status == 207) {
            that.$message.error(that.$t("device.lists.offline"));
          } else {
            that.$message.error(that.$t("global.delete.500"));
          }
        })
        .catch(function (error) {
          that.$toast.clear();
          // console.log(error);
        });
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <canvas style="display: none" ref="canvas"></canvas>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-loading="loading">
            <div class="col-lg-6" style="float: left">
              <p class="clearfix">
                <span class="float-left">{{ $t("device.detail.id") }}</span>
                <span class="float-right text-muted copyid" :data-clipboard-text="devicesdetail.ED_id"
                  @click="copyLink('copyid')">{{ devicesdetail.ED_id }}</span>
              </p>
              <p class="clearfix">
                <span class="float-left">{{ $t("device.detail.sn") }}</span>
                <span class="float-right text-muted copysn" :data-clipboard-text="devicesdetail.device_sn"
                  @click="copyLink('copysn')">{{ devicesdetail.device_sn }}</span>
              </p>
              <p class="clearfix">
                <span class="float-left">{{ $t("device.detail.name") }}</span>
                <span class="float-right text-muted">{{
                  devicesdetail.name
                }}</span>

              </p>
              <p class="clearfix">
                <span class="float-left">{{ $t("device.detail.mark") }}</span>
                <span class="float-right text-muted">{{
                  devicesdetail.remark
                }}</span>
              </p>
              <p class="clearfix">
                <span class="float-left">{{ $t("device.detail.note") }}</span>
                <span class="float-right text-muted">{{
                  devicesdetail.note
                }}</span>
              </p>

              <p class="clearfix">
                <span class="float-left">{{ $t("device.detail.error") }}</span>
                <span class="float-right">
                  <label class="badge badge-danger" v-if="devicesdetail.error_code == 31">{{ $t("device.error.error31")
                  }}</label>
                  <label class="badge badge-danger" v-else-if="devicesdetail.error_code == 32">{{
                    $t("device.error.error32") }}</label>
                  <label class="badge badge-danger" v-else-if="devicesdetail.error_code == 33">{{
                    $t("device.error.error33") }}</label>
                  <label class="badge badge-danger" v-else-if="devicesdetail.error_code == 34">{{
                    $t("device.error.error34") }}</label>
                  <label class="badge badge-danger" v-else-if="devicesdetail.error_code == 35">{{
                    $t("device.error.error35") }}</label>
                  <label class="badge badge-danger" v-else-if="devicesdetail.error_code == 36">{{
                    $t("device.error.error36") }}</label>
                  <label class="badge badge-danger" v-else-if="devicesdetail.error_code == 37">{{
                    $t("device.error.error37") }}</label>
                  <label class="badge badge-success" v-else>{{
                    $t("device.error.true")
                  }}</label>
                </span>
              </p>
            </div>
            <div class="col-lg-6 button-items" style="float: left" v-if="systemtype == 0 || systemtype == 2">
              <!-- 7620 -->
              <div v-if="devicesdetail.subid == 7620">

                <router-link :to="{ path: '/device/hd', query: { id: devicesdetail.id } }">
                  <a class="btn btn-info">
                    {{ $t("device.button.hdmanage") }}
                  </a>
                </router-link>
                <router-link :to="{
                  path: '/device/stock',
                  query: { id: devicesdetail.id },
                }">
                  <a class="btn btn-info btn-fwo">
                    {{ $t("device.button.stockmanage") }}
                  </a>
                </router-link>
                <br />
                <button class="btn btn-info mr-2" @click="itialization(devicesdetail.id)">
                  {{ $t("device.button.startup") }}
                </button>
                <button class="btn btn-info mr-2" @click="opensafedoor(devicesdetail.id)">
                  {{ $t("device.button.opendoor") }}
                </button>
                <br />
                <b-dropdown variant="secondary">
                  <template v-slot:button-content>
                    {{ $t("device.button.other") }}
                    <i class="mdi mdi-chevron-down"></i>
                  </template>
                  <b-dropdown-item href="javascript: void(0);" @click="changemode(devicesdetail.ED_id, 'pay')">{{
                    $t("device.button.modechange") }}-{{
                      $t("device.button.payment")
                    }}</b-dropdown-item>
                  <b-dropdown-item href="javascript: void(0);" @click="changemode(devicesdetail.ED_id, 'hande')">{{
                    $t("device.button.modechange") }}-{{
                      $t("device.button.handmode")
                    }}</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item href="javascript: void(0);" @click="changelang(devicesdetail.ED_id, 1)">{{
                    $t("device.button.language")
                  }}-{{
                      $t("device.button.chs")
                    }}</b-dropdown-item>
                  <b-dropdown-item href="javascript: void(0);" @click="changelang(devicesdetail.ED_id, 2)">{{
                    $t("device.button.language")
                  }}-{{
                      $t("device.button.en")
                    }}</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item href="javascript: void(0);" @click="expow(devicesdetail.ED_id)">{{
                    $t("device.button.setting") }}-{{
                      $t("device.button.sealpower")
                    }}</b-dropdown-item>
                  <b-dropdown-item href="javascript: void(0);" @click="expre(devicesdetail.ED_id)">{{
                    $t("device.button.setting") }}-{{
                      $t("device.button.pressureout")
                    }}</b-dropdown-item>
                  <b-dropdown-item href="javascript: void(0);" @click="inpre(devicesdetail.ED_id)">{{
                    $t("device.button.setting") }}-{{
                      $t("device.button.pressurein")
                    }}</b-dropdown-item>
                  <b-dropdown-item href="javascript: void(0);" @click="refushsetting(devicesdetail.ED_id)">{{
                    $t("device.button.setting")
                  }}-{{
                      $t("device.button.refresh")
                    }}</b-dropdown-item>
                </b-dropdown>
              </div>
              <div v-else-if="devicesdetail.subid == 7710">
                <button class="btn btn-info mr-2" @click="updategoodsinfo(devicesdetail.id)">
                  <i class="mdi mdi-flash mr-2"></i>
                  {{ $t("device.button.updategoods") }}
                </button>
                <button class="btn btn-success" @click="updatedevicestatus(devicesdetail.id)">
                  <i class="mdi mdi-flash-off mr-2"></i>
                  {{ $t("device.button.status") }}
                </button>
                <br />
                <router-link :to="{ path: '/device/hd', query: { id: devicesdetail.id } }">
                  <a class="btn btn-info">
                    {{ $t("device.button.hdmanage") }}
                  </a>
                </router-link>
                <router-link :to="{
                  path: '/device/stock',
                  query: { id: devicesdetail.id },
                }">
                  <a class="btn btn-info btn-fwo">
                    {{ $t("device.button.stockmanage") }}
                  </a>
                </router-link>

                <br />
                <button class="btn btn-warning" @click="restart(devicesdetail.id)">
                  <i class="mdi mdi-backup-restore mr-2"></i>
                  {{ $t("device.button.restart") }}
                </button>
              </div>
              <div v-else-if="devicesdetail.subid == 7800">
                <router-link :to="{ path: '/device/cocktailsetting', query: { id: devicesdetail.id } }">
                  <a class="btn btn-info">
                    {{ $t("device.button.cocktailsetting") }}
                  </a>
                </router-link>
                <br />
                <button class="btn btn-warning" @click="restart(devicesdetail.id)">
                  <i class="mdi mdi-backup-restore mr-2"></i>
                  {{ $t("device.button.restart") }}
                </button>
              </div>
              <div v-else-if="devicesdetail.subid == 7720" class="portugal-panel">
                <div class="portugal-toolbar">
                  <router-link :to="{ path: '/device/hd', query: { id: devicesdetail.id } }">
                    <a class="btn btn-info btn-sm">
                      <i class="mdi mdi-view-grid mr-1"></i>
                      {{ $t("device.button.hdmanage") }}
                    </a>
                  </router-link>
                  <router-link :to="{
                    path: '/device/stock',
                    query: { id: devicesdetail.id },
                  }">
                    <a class="btn btn-info btn-sm">
                      <i class="mdi mdi-package-variant mr-1"></i>
                      {{ $t("device.button.stockmanage") }}
                    </a>
                  </router-link>
                </div>

                <div class="portugal-card">
                  <div class="portugal-btn-row portugal-btn-row-first">
                    <button class="btn btn-info btn-sm" @click="portugalSyncGoods(devicesdetail.id)">
                      <i class="mdi mdi-flash mr-1"></i>
                      {{ $t("device.button.syncgoods") }}
                    </button>
                    <button class="btn btn-success btn-sm" @click="portugalSyncRemain(devicesdetail.id)">
                      <i class="mdi mdi-database-sync mr-1"></i>
                      {{ $t("device.button.syncremain") }}
                    </button>
                    <button class="btn btn-secondary btn-sm" @click="portugalInitResources(devicesdetail.id)">
                      <i class="mdi mdi-database-plus mr-1"></i>
                      {{ $t("device.portugal.initresources") }}
                    </button>
                  </div>
                </div>

                <div class="portugal-card">
                  <div class="portugal-card-title">{{ $t("device.portugal.cupprice") }}</div>
                  <div class="portugal-field-row">
                    <label class="portugal-field-label">{{ $t("device.portugal.cupprice_unit") }}</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      v-model="portugalCupPrice"
                      @blur="portugalFormatCupPrice"
                      class="form-control form-control-sm portugal-input-price"
                    />
                    <button class="btn btn-primary btn-sm" @click="portugalSaveCupPrice(devicesdetail.id)">
                      {{ $t("device.portugal.savecupprice") }}
                    </button>
                  </div>
                  <div class="portugal-hint">{{ $t("device.portugal.cupprice_hint") }}</div>
                </div>

                <div class="portugal-card">
                  <div class="portugal-field-row">
                    <label class="portugal-field-label">{{ $t("device.portugal.commmode") }}</label>
                    <select v-model.number="portugalCommMode" class="form-control form-control-sm portugal-select">
                      <option :value="0">{{ $t("device.portugal.commmode_options.0") }}</option>
                      <option :value="1">{{ $t("device.portugal.commmode_options.1") }}</option>
                      <option :value="2">{{ $t("device.portugal.commmode_options.2") }}</option>
                      <option :value="3">{{ $t("device.portugal.commmode_options.3") }}</option>
                    </select>
                    <button class="btn btn-info btn-sm" @click="portugalSaveCommMode(devicesdetail.id)">
                      {{ $t("device.portugal.commmode_save") }}
                    </button>
                  </div>
                </div>

                <div class="portugal-card">
                  <div class="portugal-field-row portugal-field-row-wrap">
                    <label class="portugal-field-label">{{ $t("device.portugal.soldout.status") }}</label>
                    <select v-model.number="portugalSoldoutStatus" class="form-control form-control-sm portugal-select-sm">
                      <option :value="2">{{ $t("device.portugal.soldout.normal") }}</option>
                      <option :value="1">{{ $t("device.portugal.soldout.sold") }}</option>
                    </select>
                    <label class="portugal-field-label portugal-field-label-inline">{{ $t("device.portugal.soldout.soldpage") }}</label>
                    <input type="number" min="0" v-model.number="portugalSoldOutPage"
                      class="form-control form-control-sm portugal-input-page" />
                    <label class="portugal-field-label portugal-field-label-inline">{{ $t("device.portugal.soldout.normalpage") }}</label>
                    <input type="number" min="0" v-model.number="portugalNormalPage"
                      class="form-control form-control-sm portugal-input-page" />
                    <button class="btn btn-warning btn-sm" @click="portugalSetSoldout(devicesdetail.id)">
                      {{ $t("device.portugal.soldout.apply") }}
                    </button>
                  </div>
                </div>

                <div class="portugal-card">
                  <div class="portugal-card-title">{{ $t("device.portugal.pulse.title") }}</div>
                  <div class="portugal-field-row portugal-field-row-wrap">
                    <label class="portugal-field-label portugal-field-label-inline">{{ $t("device.portugal.pulse.lane", { n: 1 }) }}</label>
                    <input type="number" min="0" v-model.number="portugalPulse[1]"
                      class="form-control form-control-sm portugal-input-pulse" />
                    <label class="portugal-field-label portugal-field-label-inline">{{ $t("device.portugal.pulse.lane", { n: 2 }) }}</label>
                    <input type="number" min="0" v-model.number="portugalPulse[2]"
                      class="form-control form-control-sm portugal-input-pulse" />
                    <label class="portugal-field-label portugal-field-label-inline">{{ $t("device.portugal.pulse.lane", { n: 3 }) }}</label>
                    <input type="number" min="0" v-model.number="portugalPulse[3]"
                      class="form-control form-control-sm portugal-input-pulse" />
                    <label class="portugal-field-label portugal-field-label-inline">{{ $t("device.portugal.pulse.lane", { n: 4 }) }}</label>
                    <input type="number" min="0" v-model.number="portugalPulse[4]"
                      class="form-control form-control-sm portugal-input-pulse" />
                    <button class="btn btn-primary btn-sm" @click="portugalSavePulse(devicesdetail.id)">
                      {{ $t("device.portugal.pulse.save") }}
                    </button>
                  </div>
                </div>

                <div class="portugal-card">
                  <div class="portugal-card-title portugal-card-title-row">
                    <span>{{ $t("device.portugal.exception.title") }}</span>
                    <button class="btn btn-outline-secondary btn-sm" @click="loadPortugalExceptions" :disabled="portugalExceptionLoading">
                      <i class="mdi mdi-refresh mr-1"></i>
                      {{ $t("device.portugal.exception.refresh") }}
                    </button>
                  </div>
                  <el-table
                    :data="portugalExceptionList"
                    v-loading="portugalExceptionLoading"
                    stripe
                    border
                    size="mini"
                    :empty-text="$t('global.text.nodata') || '暂无数据'"
                    style="width: 100%"
                  >
                    <el-table-column
                      prop="addtime_text"
                      :label="$t('device.portugal.exception.time')"
                      width="160"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="order_id"
                      :label="$t('device.portugal.exception.order')"
                      width="90"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.order_id > 0 ? scope.row.order_id : '-' }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="exception_code"
                      :label="$t('device.portugal.exception.code')"
                      width="100"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-tag
                          size="mini"
                          :type="scope.row.exception_code === 'E8808' ? 'warning' : 'danger'"
                        >{{ portugalExceptionLabel(scope.row) }}</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="message"
                      :label="$t('device.portugal.exception.message')"
                      show-overflow-tooltip
                    ></el-table-column>
                  </el-table>
                  <div class="portugal-exception-pager" v-if="portugalExceptionTotal > 0">
                    <el-pagination
                      small
                      layout="total, prev, pager, next"
                      :current-page="portugalExceptionPage"
                      :page-size="portugalExceptionLimit"
                      :total="portugalExceptionTotal"
                      @current-change="handlePortugalExceptionPageChange"
                    ></el-pagination>
                  </div>
                </div>

                <div class="portugal-footer">
                  <button class="btn btn-warning btn-sm" @click="restart(devicesdetail.id)">
                    <i class="mdi mdi-backup-restore mr-1"></i>
                    {{ $t("device.button.restart") }}
                  </button>
                </div>
              </div>
              <!-- Else -->
              <div v-else>
                <router-link :to="{ path: '/device/hd', query: { id: devicesdetail.id } }">
                  <a class="btn btn-info">
                    {{ $t("device.button.hdmanage") }}
                  </a>
                </router-link>
                <router-link :to="{
                  path: '/device/stock',
                  query: { id: devicesdetail.id },
                }">
                  <a class="btn btn-info btn-fwo">
                    {{ $t("device.button.stockmanage") }}
                  </a>
                </router-link>

                <br />
                <button class="btn btn-warning" @click="restart(devicesdetail.id)">
                  <i class="mdi mdi-backup-restore mr-2"></i>
                  {{ $t("device.button.restart") }}
                </button>

                <el-button class="btn" type="primary" v-if="devicesdetail.imei == '1'"
                  @click="switchstocktips(devicesdetail.ED_id)">{{
                    $t("device.button.setstock")
                  }}</el-button>
                <el-button class="btn" type="warning" v-else @click="switchstocktips(devicesdetail.ED_id)">{{
                  $t("device.button.nostock") }}</el-button>
                <br />
                <button class="btn btn-info btn-fwo" @click="showqrcode(devicesdetail.device_sn)">
                  <i class="mdi mdi-backup-restore mr-2"></i>
                  {{ $t("device.button.qrcode") }}
                </button>
              </div>
            </div>
            <div class="col-lg-6 button-items" style="float: left" v-if="systemtype == 1">
              <router-link :to="{
                path: '/device/baropen',
                query: { id: devicesdetail.id },
              }">
                <a class="btn btn-success" href="javascript:;">
                  <i class="mdi mdi-flash mr-2"></i>
                  {{ $t("device.button.openstage") }}
                </a>
              </router-link>

              <router-link :to="{
                path: '/device/barclose',
                query: { id: devicesdetail.id },
              }">
                <a class="btn btn-success" href="javascript:;">
                  <i class="mdi mdi-flash-off mr-2"></i>
                  {{ $t("device.button.closestage") }}
                </a>
              </router-link>
              <br />
              <router-link :to="{ path: '/device/hd', query: { id: devicesdetail.id } }">
                <a class="btn btn-info">
                  {{ $t("device.button.hdmanage") }}
                </a>
              </router-link>
              <router-link :to="{
                path: '/device/stock',
                query: { id: devicesdetail.id },
              }">
                <a class="btn btn-info btn-fwo">
                  {{ $t("device.button.stockmanage") }}
                </a>
              </router-link>
              <button type="button" class="btn btn-info" v-if="systemtype == 1"
                @click="devicecheckout(devicesdetail.id)">
                {{ $t("device.button.checkout") }}
              </button>
              <br />
              <button class="btn btn-warning" @click="restart(devicesdetail.id)">
                <i class="mdi mdi-backup-restore mr-2"></i>
                {{ $t("device.button.restart") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t("device.detail.system.text") }}</span>
          </div>
          <div class="row button-items">
            <button class="btn btn-info" @click="resetdevicepwd(devicesdetail.id)">
              <i class="mdi mdi-backup-restore mr-2"></i>
              {{ $t("device.button.resetpwd") }}
              </button>
              <button class="btn btn-info" @click="showScreenPicUpload = true">
                <i class="mdi mdi-upload mr-2"></i>
                {{ $t("device.detail.system.screenpic") }}
              </button>
              <!-- 设置库存预警比例 -->
              <button class="btn btn-info" @click="set_stock_if(devicesdetail.id)">
                {{ $t("device.button.stock_if") }}
              </button>
              <button class="btn btn-info" @click="set_devices_name(devicesdetail.id)">
                {{ $t("device.button.devicename") }}
              </button>
              <button class="btn btn-info" @click="setRuntimeSetting()">
                <i class="mdi mdi-clock mr-2"></i>
                {{ $t("device.button.runtime") }}
              </button>
          </div>
        </el-card>
      </div>
      <el-dialog :title="$t('device.detail.system.screenpic')" style="text-align: center;" :close-on-click-modal="false"
        :visible.sync="showScreenPicUpload" width="50%" v-loading="loadingScreenPicStatus"
        :element-loading-text="loadingScreenText" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-upload class="avatar-uploader" action="https://update.aicoiot.com/saasimg/upload.php" :show-file-list="false"
          :on-success="handleAvatarSuccess" :before-upload="beforeUpload" method="post" name="source">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showScreenPicUpload = false">{{ $t("global.return") }}</el-button>
        </span>
      </el-dialog>
      
      <!-- 经营时间设置对话框 -->
      <el-dialog :title="$t('device.detail.runtime.title')" :visible.sync="showRuntimeSettingDialog" width="400px">
        <el-form label-width="120px">
          <el-form-item :label="$t('device.detail.runtime.begin')">
            <el-time-picker
              v-model="runtimeBegin"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              placeholder="选择开始时间">
            </el-time-picker>
          </el-form-item>
          <el-form-item :label="$t('device.detail.runtime.end')">
            <el-time-picker
              v-model="runtimeEnd"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              placeholder="选择结束时间">
            </el-time-picker>
          </el-form-item>
        </el-form>
        <div style="margin-top: 10px; padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
          <i class="el-icon-info" style="color: #409eff; margin-right: 5px;"></i>
          <span style="color: #606266; font-size: 12px;">{{ $t('device.detail.runtime.note') }}</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showRuntimeSettingDialog = false">{{ $t("global.button.cancel") }}</el-button>
          <el-button type="primary" @click="saveRuntimeSetting()">{{ $t("global.button.ok") }}</el-button>
        </span>
      </el-dialog>

      <!-- 库存重置日志对话框 -->
      <el-dialog 
        :title="$t('device.detail.stocklog.title') || '库存重置日志'" 
        :visible.sync="showStockLogDialog" 
        width="80%"
        :close-on-click-modal="false"
      >
        <el-table 
          :data="stockLogList" 
          v-loading="stockLogLoading"
          stripe
          border
          :empty-text="$t('global.text.nodata') || '暂无数据'"
          style="width: 100%"
        >
          <el-table-column 
            prop="time" 
            :label="$t('device.detail.stocklog.time') || '时间'" 
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column 
            prop="action" 
            :label="$t('device.detail.stocklog.action') || '操作'" 
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag size="small">{{ scope.row.action || '-' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column 
            prop="user" 
            :label="$t('device.detail.stocklog.user') || '操作人'" 
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column 
            prop="remark" 
            :label="$t('device.detail.stocklog.remark') || '备注'"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        
        <!-- 分页组件 -->
        <div style="margin-top: 20px; text-align: right;" v-if="stockLogTotal > 0">
          <el-pagination
            @size-change="handleStockLogSizeChange"
            @current-change="handleStockLogPageChange"
            :current-page="stockLogPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="stockLogLimit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="stockLogTotal"
          ></el-pagination>
        </div>
        <div v-else-if="!stockLogLoading" style="text-align: center; padding: 20px; color: #909399;">
          <i class="el-icon-info"></i>
          {{ $t("device.detail.stocklog.no_data") || "暂无日志数据" }}
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showStockLogDialog = false">{{ $t("global.button.close") || "关闭" }}</el-button>
        </span>
      </el-dialog>

      <!-- 维护日志对话框 -->
      <el-dialog 
        :title="$t('device.detail.maintainlog.title') || '维护日志'" 
        :visible.sync="showMaintainLogDialog" 
        width="80%"
        :close-on-click-modal="false"
      >
        <el-table 
          :data="maintainLogList" 
          v-loading="maintainLogLoading"
          stripe
          border
          :empty-text="$t('global.text.nodata') || '暂无数据'"
          style="width: 100%"
        >
          <el-table-column 
            prop="time" 
            :label="$t('device.detail.maintainlog.time') || '时间'" 
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column 
            prop="action" 
            :label="$t('device.detail.maintainlog.action') || '操作'" 
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag 
                :type="scope.row.action === 'open' ? 'success' : 'warning'" 
                size="small"
              >
                {{ scope.row.action === 'open' ? ($t('device.detail.maintainlog.open') || '开启') : ($t('device.detail.maintainlog.close') || '关闭') }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column 
            prop="user" 
            :label="$t('device.detail.maintainlog.user') || '操作人'" 
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column 
            prop="remark" 
            :label="$t('device.detail.maintainlog.remark') || '备注'"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        
        <!-- 分页组件 -->
        <div style="margin-top: 20px; text-align: right;" v-if="maintainLogTotal > 0">
          <el-pagination
            @size-change="handleMaintainLogSizeChange"
            @current-change="handleMaintainLogPageChange"
            :current-page="maintainLogPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="maintainLogLimit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="maintainLogTotal"
          ></el-pagination>
        </div>
        <div v-else-if="!maintainLogLoading" style="text-align: center; padding: 20px; color: #909399;">
          <i class="el-icon-info"></i>
          {{ $t("device.detail.maintainlog.no_data") || "暂无日志数据" }}
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showMaintainLogDialog = false">{{ $t("global.button.close") || "关闭" }}</el-button>
        </span>
      </el-dialog>
    </div>
  </Layout>
</template>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 304px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 304px;
  height: 178px;
  display: block;
}

.portugal-panel {
  max-width: 100%;
}

.portugal-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.portugal-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 10px;
}

.portugal-card-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #343a40;
  margin-bottom: 10px;
}

.portugal-card-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.portugal-input-pulse {
  width: 96px;
}

.portugal-exception-pager {
  margin-top: 12px;
  text-align: right;
}

.portugal-field-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.portugal-field-row-wrap {
  row-gap: 10px;
}

.portugal-field-label {
  min-width: 88px;
  margin-bottom: 0;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #495057;
  flex-shrink: 0;
}

.portugal-field-label-inline {
  min-width: auto;
  margin-left: 4px;
}

.portugal-input-num {
  width: 120px;
}

.portugal-select {
  width: 140px;
}

.portugal-select-sm {
  width: 130px;
}

.portugal-input-page {
  width: 72px;
}

.portugal-btn-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #dee2e6;
}

.portugal-btn-row-first {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}

.portugal-input-price {
  width: 120px;
}

.portugal-hint {
  margin-top: 8px;
  font-size: 0.75rem;
  color: #6c757d;
}

.portugal-footer {
  margin-top: 4px;
}
</style>